export enum SiteSection {
  LISTAGEM_USUARIOS = "ListagemUsuarios",
  LISTAGEM_USUARIOS_EXCLUIDOS = "ListagemUsuariosExcluidos",
  DETALHES_USUARIO = "DetalhesUsuario",
  EDITAR_USUARIO = "EditarUsuario",
  REDEFINIR_SENHA = "RedefinirSenha",
  BLOQUEAR_USUARIO = "BloquearUsuario",
  DESBLOQUEAR_USUARIO = "DesbloquearUsuario",
  ACEITE_TERMOS = "AceiteTermosDeUso",
  REVISAO_ACESSOS = "RevisaoAcessos",
  RECERTIFICACAO_PERIODICA = "RecertificacaoPeriodica",
  CLONAR_USUARIO = "ClonarUsuario",
  PORTAL_LOGONS = "PortalLogonsDashboard",

  ERRO_REDEFINIR_SENHA = "ErroAoRedefinirSenha",
  ERRO_EDITAR_USUARIO = "ErroAoEditarUsuario",
  ERRO_AO_BUSCAR_USUARIO_CLONAVEL = "ErroAoBuscarUsuarioClonavel",
  ERRO_AO_CLONAR_USUARIO = "ErroAoClonarUsuario",
  ERRO_LISTAGEM_USUARIOS = "ErroAoCarregarListagemUsuarios",
  ERRO_DETALHES_USUARIO = "ErroAoConsultarDetalhesUsuario",
  ERRO_AO_BLOQUEAR_USUARIO = "ErroAoBloquearUsuario",
  ERRO_AO_DESBLOQUEAR_USUARIO = "ErroAoDesbloquearUsuario",
  ERRO_AO_ACEITAR_TERMO = "ErroAoAceitarTermo",
  ERRO_RECERTIFICACAO_PERIODICA = "ErroNaRecertificacaoPeriodica",
  ERRO_AO_RENOVAR_ACESSO_USUARIO = "ErroAoRenovarAcessoUsuario",
  ERRO_AO_BLOQUEAR_ACESSO_USUARIO = "ErroAoBloquearAcessoUsuario",
  ERRO_AO_DELETAR_USUARIO = "ErroAoDeletarUsuario",
  ERRO_LISTAGEM_USUARIOS_EXCLUIDOS = "ErroAoCarregarListagemUsuariosExcluidos",

}
